import { IAccount } from './account.type';
import { IAddress } from './address.type';
import { ICategoryNews } from './categoryNews.type';
import { IBaseEntity, IBaseQuery } from './common.type';
import { IDevice } from './device.type';
import { IJob } from './job.type';
import { IPlaylistDevice } from './playlist_device.type';
import { EPlaylistSourceType, IPlaylistSource } from './playlist_source.type';
import { ISoundQuality } from './soundQuality.type';

export interface IPlaylist extends IBaseEntity {
  code: string;
  name: string;
  mode: EPlaylistMode;
  note?: string;
  priority: number;
  type: EPlaylistType;
  playback_count: number;
  total_time?: number;
  approve_at?: string;
  approve_by?: string;
  is_playing?: number;
  time_start?: string;
  cancel_at?: string;
  play_status?: number;
  time_end?: string;
  date_start?: string;
  date_end?: string;
  day_of_week?: string;
  day_of_month?: string;
  is_played?: number;
  time?: string;
  si_id?: string;
  category_news_id?: string;
  sound_quality_id?: string;
  device_stream?: string;
  address: IAddress[];
  jobs: IJob[];
  user_approved?: IAccount;
  category_news?: ICategoryNews;
  micro_stream?: IDevice;
  sound_quality?: ISoundQuality;
  // source_information source_information?
  devices: IPlaylistDevice[];
  playlist_sources: IPlaylistSource[];
}

export interface IPlaylistQuery extends IBaseQuery {
  createdName?: string;
  approvedName?: string;
  communeId?: string;
  provinceId?: string;
  villageId?: string;
}

export interface IPlaylistBody {
  code: string;
  name: string;
  mode: 'INSTANT' | 'SCHEDULED';
  note?: string;
  sound_quality_id: string;
  category_news_id: string;
  priority: number;
  receiverDeviceIds: any[];
  playbackCount: number;
  type: 'ONCE' | 'BY_DATE' | 'BY_WEEK' | 'BY_MONTH';
  scheduleStartDate: string;
  scheduleEndDate: string;
  scheduleStartTime: string[];
  dayOfWeek?: number[];
  dayOfMonth?: number[];
  playSource: IPlaySourceBody[];
  relaySourceReq: any[];
  files: any[];
  fileInfor: any[];
  total_time: number;
  textToSpeech: ITextToSpeech[];
}

export interface ITextToSpeech {
  title: string;
  textToSpeechId: string;
  no: number;
  volume: number;
}

export interface IPlaySourceBody {
  contentId: string;
  albumId: string;
  no: number;
  volume: number;
  type: EPlaylistSourceType.LIST;
  contentType: 'SINGLE' | 'ALBUM';
}

export interface IUpdatePlaylistBody extends IPlaylistBody {
  deleteIds: string[];
  sourceUpdate: { id: string; no: number; volume: number }[];
  playlistScheduleUpdate: any[];
  receiverDeviceDeleteIds: string[];
}

export interface IPlayListSourceData {
  id: string;
  title: string;
  type: EPlaylistSourceType;
  url?: string;
  originId?: string;
  time?: number;
  albumId?: string;
  contentId?: string;
  contentType?: 'SINGLE' | 'ALBUM';
  relayId?: string;
  volume?: number;
  textToSpeechId?: string;
  note?: string;
}

export enum EPlaylistMode {
  INSTANT = 'INSTANT',
  SCHEDULED = 'SCHEDULED',
}

export enum EPlaylistType {
  ONCE = 'ONCE',
  BY_DATE = 'BY_DATE',
  BY_WEEK = 'BY_WEEK',
  BY_MONTH = 'BY_MONTH',
}
